import { router } from '@inertiajs/react'
import { useEffect } from 'react'
import { toast } from 'sonner'
import { Toaster } from '@/components/ui/sonner'

/** Renders Rails flash (notice/alert) as toasts on every Inertia visit. */
export function FlashToaster() {
  useEffect(
    () =>
      router.on('flash', (event) => {
        const { notice, alert } = event.detail.flash
        if (notice) toast.success(notice)
        if (alert) toast.error(alert)
      }),
    [],
  )
  return <Toaster position="top-center" richColors />
}
